import { SelectionOverlay } from './SelectionOverlay';
import { BeaconPins } from './BeaconPins';
import { FlyToListener } from './FlyToListener';
import { FocusComuniLayer } from './FocusComuniLayer';
import { useReconcileSaved } from './useReconcileSaved';

// Bundle of map-side components that must live inside MapContainer.
export function PlacesMapLayers() {
  // Однократная синхронизация при старте: удаляет «сиротские» istats
  // из usePlacesStore, которые накопились до введения sync-логики
  // в AddToShortlistButton. Подробнее — в useReconcileSaved.ts.
  useReconcileSaved();
  return (
    <>
      <SelectionOverlay />
      <BeaconPins />
      <FocusComuniLayer />
      <FlyToListener />
    </>
  );
}
